import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

export default function MarketingHeader() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled]   = useState(false)
  const location = useLocation()

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 80)
    window.addEventListener('scroll', fn)
    return () => window.removeEventListener('scroll', fn)
  }, [])

  useEffect(() => { setMenuOpen(false) }, [location.pathname])

  const navLinks = [
    { label:'Features', to:'/features' },
    { label:'Stories',  to:'/stories'  },
    { label:'About',    to:'/about'    },
    { label:'Pricing',  to:'/pricing'  },
    { label:'Docs',     to:'/docs'     },
  ]

  const linkStyle = (to) => ({
    fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', fontWeight:600,
    color: location.pathname===to ? '#1A1A1A' : '#6B6B6B',
    textDecoration:'none', transition:'color 0.2s',
  })

  return (
    <>
      <style>{`
        .mkt-nav-link:hover { color: #C4826A !important; }
        @keyframes menuSlide { from { opacity:0; transform:translateY(-8px) } to { opacity:1; transform:none } }
        @media (max-width:768px) { .mkt-center-nav { display:none !important; } }
      `}</style>

      {/* Floating pill navbar */}
      <header style={{
        position:'fixed', top:20, left:'50%', transform:'translateX(-50%)',
        width:'calc(100% - 48px)', maxWidth:1140,
        background: scrolled ? 'rgba(250,250,248,0.96)' : 'rgba(250,250,248,0.85)',
        backdropFilter:'blur(16px) saturate(1.8)',
        border:'1px solid rgba(229,224,216,0.6)',
        borderRadius:100, boxShadow:'0 4px 24px rgba(0,0,0,0.06)',
        padding:'0.75rem 1.5rem',
        display:'flex', alignItems:'center', justifyContent:'space-between',
        zIndex:100, transition:'background 0.3s',
      }}>
        {/* Logo */}
        <Link to="/" style={{ flexShrink:0 }}>
          <img src="/okoiya-logo.png" alt="Okoiya" style={{ height:32, objectFit:'contain', display:'block' }}/>
        </Link>

        {/* Center nav — desktop */}
        <div className="mkt-center-nav" style={{ display:'flex', gap:'1.75rem', alignItems:'center' }}>
          {navLinks.map(l=>(
            <Link key={l.to} to={l.to} className="mkt-nav-link" style={linkStyle(l.to)}>{l.label}</Link>
          ))}
        </div>

        {/* Right buttons — desktop */}
        <div className="mkt-center-nav" style={{ display:'flex', gap:'0.75rem', alignItems:'center' }}>
          <Link to="/login" className="mkt-nav-link" style={linkStyle('/login')}>Sign In</Link>
          <Link to="/signup">
            <button style={{ fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.8rem', color:'white', background:'#C4826A', border:'none', borderRadius:100, padding:'0.6rem 1.4rem', cursor:'pointer', transition:'background 0.2s' }}
              onMouseEnter={e=>e.currentTarget.style.background='#B36B55'}
              onMouseLeave={e=>e.currentTarget.style.background='#C4826A'}>
              Get Started Free →
            </button>
          </Link>
        </div>

        {/* Hamburger — mobile */}
        <button onClick={()=>setMenuOpen(o=>!o)} style={{ display:'none', background:'none', border:'none', cursor:'pointer', color:'#1A1A1A', padding:4 }}
          className="mkt-hamburger">
          {menuOpen ? <X size={22}/> : <Menu size={22}/>}
        </button>
      </header>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div style={{
          position:'fixed', top:80, left:24, right:24,
          background:'rgba(250,250,248,0.97)', backdropFilter:'blur(12px)',
          border:'1px solid rgba(229,224,216,0.6)', borderRadius:20,
          padding:'1.25rem 1.5rem', display:'flex', flexDirection:'column', gap:'1rem',
          zIndex:99, animation:'menuSlide 0.2s ease-out',
        }}>
          {navLinks.map(l=>(
            <Link key={l.to} to={l.to} style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'1rem', fontWeight:600, color:'#1A1A1A', textDecoration:'none' }}>{l.label}</Link>
          ))}
          <Link to="/login" style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'1rem', fontWeight:600, color:'#1A1A1A', textDecoration:'none' }}>Sign In</Link>
          <Link to="/signup">
            <button style={{ width:'100%', fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.9rem', color:'white', background:'#C4826A', border:'none', borderRadius:100, padding:'0.875rem', cursor:'pointer' }}>
              Get Started Free →
            </button>
          </Link>
        </div>
      )}

      {/* Spacer so page content clears fixed nav */}
      <div style={{ height:80 }}/>

      <style>{`
        @media (max-width:768px) {
          .mkt-hamburger { display:flex !important; }
          .mkt-center-nav { display:none !important; }
        }
      `}</style>
    </>
  )
}
